<template>
  <div class="FS-slide view-slide">
    <img src="../../assets/images/farm-shots.png" />
    <div class="slide-text-part">
      <!-- <h3>Farm shots</h3> -->
      <img src="../../assets/images/cropwise-img-logo.png"  v-on:click="select($event)">
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>See customers’ fields in a whole new way...<br/>
        Syngenta Imagery is a service that provides the opportunity to view customer fields through a different lens using multiple forms of imagery sources and styles.  Being able to detect disease, pests, and plant nutrition will fuel new in season conversations.
      </p>
      <div class="text-center">
        <button v-on:click="select($event)">OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "FarmshotsComponent"
};
</script>

